const homepage = '/gifting';

export const addPathPrefix = (path, { newGifting } = { newGifting: true }) =>
  newGifting ? [path, `${homepage}${path}`] : [path];

export const getImagesStaticUrl = (url) =>
  url.startsWith('http') ? url : `${process.env.REACT_APP_STATIC_MEDIA}/images/${url}`;
